export default __webpack_public_path__ + "73eda956b0b660641fe9fc172aacb984.svg";